import React from "react"
import TableRow from "material-ui/Table/TableRow"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import * as timeHelper from "../../helpers/timeHelper"
import { ITimecardWeek } from "../../models"
interface IProps {
    timecardWeek: ITimecardWeek
}

const EquipmentTimecardGrandTotalRow: React.SFC<IProps> = (props: IProps) => {
    return (
        <TableRow className="EquipmentTimecardGrandTotalRow" style={{ borderTop: "solid 3px #999999", borderBottom: "" }}>
            <TableRowColumn>
                <table style={{ width: "100%", paddingTop: 10, color: "#888888" }}>
                    <tbody>
                        <tr>
                            <td>Week Total:</td>
                            <td>{timeHelper.convertToHour(props.timecardWeek.TotalProductiveInMinutes)}</td>
                            <td>hrs</td>
                        </tr>
                    </tbody>
                </table>
            </TableRowColumn>
            <TableRowColumn />
            <TableRowColumn />
            <TableRowColumn />
            <TableRowColumn />
            <TableRowColumn />
            <TableRowColumn />
        </TableRow>
    )
}

export default EquipmentTimecardGrandTotalRow
